const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function utcDate(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month - 1, day));
}

export function isoDateStringToLocalDate(value?: string): Date | null {
  const parts = ISO_DATE_PATTERN.exec(value ?? '');
  if (!parts) {
    return null;
  }
  const [, year, month, day] = parts;
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  const isRealDate = date.getFullYear() === Number(year)
    && date.getMonth() === Number(month) - 1
    && date.getDate() === Number(day);
  return isRealDate ? date : null;
}
